import React from 'react';
import { useTranslation } from 'next-i18next';
import NextLink from 'next/link';
import { Avatar } from '@dentalux/ui-library-core/components/avatar';
import { Link } from '@mui/material';
import { CalendarIcon } from 'src/components/icons/Calendar';
import ClockIcon from 'src/components/icons/Clock';
import PractitionerDetails from 'src/components/PractitionerDetails';
import getPractitionerRoles from 'src/helpers/getPractitionerRoles';
import * as S from '../../AppointmentView.styles';
import DentalTreatments from '..//DentalTreatments';
const MobileView = ({
  date,
  time,
  treatmentTitle,
  treatments,
  practitioner,
  clinic,
  LocationLink,
  labels
}) => {
  const {
    t,
    i18n: {
      language
    }
  } = useTranslation();
  const orientation = 'vertical';
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(S.SectionItem, {
    icon: /*#__PURE__*/React.createElement(CalendarIcon, null),
    orientation: orientation,
    label: t('b2c.appointments.appointmentSchedule'),
    value: /*#__PURE__*/React.createElement(S.DateTime, null, date, time && [/*#__PURE__*/React.createElement(ClockIcon, {
      key: "time"
    }), time])
  }), practitioner && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(S.Divider, null), /*#__PURE__*/React.createElement(S.SectionItem, {
    orientation: orientation,
    label: /*#__PURE__*/React.createElement(PractitionerDetails, {
      size: "small",
      avatar: /*#__PURE__*/React.createElement(Avatar, {
        src: practitioner?.imageUrl
      }),
      title: /*#__PURE__*/React.createElement(NextLink, {
        href: `/practitioner/${practitioner.referenceId}`,
        passHref: true
      }, /*#__PURE__*/React.createElement(Link, {
        target: "_blank"
      }, practitioner.name)),
      subTitle: getPractitionerRoles(practitioner, t, language),
      description: clinic.officialName
    })
  })), treatmentTitle && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(S.Divider, null), /*#__PURE__*/React.createElement(S.SectionItem, {
    orientation: orientation,
    label: labels.treatment,
    value: treatmentTitle
  })), treatments.length > 0 && /*#__PURE__*/React.createElement(S.SectionItem, {
    sx: {
      pt: treatmentTitle ? 1 : 0
    },
    orientation: orientation,
    label: labels.details,
    value: /*#__PURE__*/React.createElement(DentalTreatments, {
      data: treatments
    })
  }), /*#__PURE__*/React.createElement(S.Divider, null), !!LocationLink && /*#__PURE__*/React.createElement(S.SectionItem, {
    orientation: orientation,
    label: labels.findUs,
    value: LocationLink
  }), /*#__PURE__*/React.createElement(S.SectionItem, {
    sx: {
      pt: LocationLink ? 1 : 0
    },
    label: practitioner ? labels.callClinic : labels.clinic,
    orientation: orientation,
    value: practitioner ? /*#__PURE__*/React.createElement(Link, {
      href: `tel:${clinic.phoneNumber}`
    }, clinic.phoneNumber) : clinic.officialName
  }));
};
export default MobileView;